import type { FaireProductEntity } from "../../entity_types/product";

export const p_6trlzb6r: FaireProductEntity = {
  token: "p_6trlzb6r",
  type: "product",
  name: "Nice Buns Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/435151d7b08a9f58ab0141bdb6fce65b1a8e3205e90b3de42b65203fe2932f83/1528360446.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b2323ea3763a6287979eac58cd0dca4d1adfdbab863ee471e7ca3a241e974314/1528360446.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:11.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
